import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Youtube, Twitter, Linkedin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#2C221F] border-t border-[#3D302C] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_indie-label-hub-2/artifacts/gvux7vc5_IMG_8054.jpeg" 
              alt="Vintage Ave Records"
              className="h-20 w-auto mb-4"
            />
            <p className="text-[#A89B95] text-sm">
              Breaking the frequency of the digital divide. Real music. Real artists.
            </p>
          </div>
          
          <div>
            <h3 className="text-[#FDFBF7] font-['Playfair_Display'] text-lg mb-4">Quick Links</h3>
            <div className="space-y-2">
              <Link to="/roster" className="block text-[#A89B95] hover:text-[#D97736] text-sm transition-colors">
                Our Team
              </Link>
              <Link to="/music" className="block text-[#A89B95] hover:text-[#D97736] text-sm transition-colors">
                Music
              </Link>
              <Link to="/news" className="block text-[#A89B95] hover:text-[#D97736] text-sm transition-colors">
                News & Events
              </Link>
              <Link to="/shop" className="block text-[#A89B95] hover:text-[#D97736] text-sm transition-colors">
                Merch Shop
              </Link>
              <Link to="/submit" className="block text-[#A89B95] hover:text-[#D97736] text-sm transition-colors">
                Submit Your Work
              </Link>
            </div>
          </div>
          
          <div>
            <h3 className="text-[#FDFBF7] font-['Playfair_Display'] text-lg mb-4">Connect With Us</h3>
            <div className="flex gap-3 mb-4">
              <a href="https://instagram.com/vintageaverecords" target="_blank" rel="noopener noreferrer" className="text-[#A89B95] hover:text-[#D97736] transition-colors p-2 bg-[#3D302C] rounded-full hover:bg-[#D97736] hover:text-white">
                <Instagram size={18} />
              </a>
              <a href="https://facebook.com/VINTAGEAVERECORDS" target="_blank" rel="noopener noreferrer" className="text-[#A89B95] hover:text-[#D97736] transition-colors p-2 bg-[#3D302C] rounded-full hover:bg-[#D97736] hover:text-white">
                <Facebook size={18} />
              </a>
              <a href="https://youtube.com/@VintageAveRecordsSoulMusic" target="_blank" rel="noopener noreferrer" className="text-[#A89B95] hover:text-[#D97736] transition-colors p-2 bg-[#3D302C] rounded-full hover:bg-[#D97736] hover:text-white">
                <Youtube size={18} />
              </a>
              <a href="https://twitter.com/VINTAGEAVEMUSIC" target="_blank" rel="noopener noreferrer" className="text-[#A89B95] hover:text-[#D97736] transition-colors p-2 bg-[#3D302C] rounded-full hover:bg-[#D97736] hover:text-white">
                <Twitter size={18} />
              </a>
              <a href="https://linkedin.com/in/vintageaverecords" target="_blank" rel="noopener noreferrer" className="text-[#A89B95] hover:text-[#D97736] transition-colors p-2 bg-[#3D302C] rounded-full hover:bg-[#D97736] hover:text-white">
                <Linkedin size={18} />
              </a>
            </div>
            <p className="text-[#A89B95] text-sm mb-2">vintageaverecords@gmail.com</p>
            <p className="text-[#A89B95] text-sm mb-2">(678) 973-6428</p>
            <p className="text-[#A89B95] text-sm">© 2026 Vintage Ave Records</p>
          </div>
        </div>
      </div>
    </footer>
  );
};